import type { Sandbox } from '../modules/sandboxes/types.js';

interface WireSandbox {
  id: string;
  name: string;
  storageType: string;
  mode: string;
  orgId: string;
  userId: string;
  createdAt: string;
  disabled?: boolean;
  // Legacy wire alternates: backend may send projectId or workspaceId.
  projectId?: string | null;
  workspaceId?: string | null;
}

export const sandboxAdapter = {
  fromListResponse(payload: unknown): Sandbox[] {
    const list = (payload as { repos?: WireSandbox[]; sandboxes?: WireSandbox[] } | null)?.repos
      ?? (payload as { sandboxes?: WireSandbox[] } | null)?.sandboxes
      ?? [];
    return list.map(normalize);
  },

  fromGetResponse(payload: unknown): Sandbox {
    const wire = payload as { repo?: WireSandbox; sandbox?: WireSandbox; data?: WireSandbox } | null;
    const value = wire?.repo ?? wire?.sandbox ?? wire?.data;
    if (!value) throw new Error('Sandbox response missing body.');
    return normalize(value);
  },

  normalize,
};

function normalize(wire: WireSandbox): Sandbox {
  return {
    id: wire.id,
    name: wire.name,
    storageType: wire.storageType,
    mode: wire.mode,
    orgId: wire.orgId,
    userId: wire.userId,
    projectId: wire.projectId ?? wire.workspaceId ?? null,
    createdAt: wire.createdAt,
    disabled: wire.disabled ?? false,
  };
}

// TODO(backend-cleanup): cloud-agent-backend internal/http/routes/sandbox/sandbox.go
// still returns `repos` / `repo` response keys, and Sandbox JSON may carry
// `workspaceId` instead of `projectId` (internal/domain/types.go). When both
// are renamed, this adapter collapses to a plain unwrap.
